<template>
	<div class="order-item">
		<div class="order-title" @click.stop="checkedItem">

			<div class="title">
				<span>订单号：{{ item.order_no }}</span>
				<span>下单时间：{{ item.create_time }}</span>
			</div>
			<template v-if="isEdit">
				<img v-if="isChecked" src="@/assets/images/select.png" class="icon-checkbox" style="width: 17px;height: 17px;" />
				<img v-else src="@/assets/images/no-select.png" class="icon-checkbox" style="width: 17px;height: 17px;" />
			</template>
			<div class="delete"></div>
		</div>
		<div class="order-content" @click.stop="toDetail">
			<template v-if="item.order_type == 0">
				<div class="img-box border-right flex flex-wrap" >
					<div class="flex" style="margin:10px 0" v-for="(i,index) in item.products" :key="index">
						<img :src="i.product_image" />
						<div class="name">{{ i.product_name }}</div>
					</div>
				</div>
				<div class="detail-box border-right flex flex-wrap">
					<div  class="" style="margin:10px 0" v-for="(i,index) in item.products" :key="index">
						<div>{{ i.spec_name }}</div>
						<div>数量：{{i.quantity}}</div>
						<div>单价：￥{{ i.price }}</div>
					</div>
				</div>
			</template>
			<template v-else-if="item.order_type == 2">
				<div class="img-box border-right" >
					<div class="flex">
						<img v-if="item.design2d.template.main_image" :src="item.design2d.template.main_image" />
						<div class="name">{{ item.design2d.t_name }}</div>
					</div>
				</div>
				<div class="detail-box border-right">
					<div class="">
						<div>{{ item.design2d.d_name }}</div>
						<div>数量：{{item.design2d.quantity}}</div>
						<div>单价：￥{{ item.design2d.price }}</div>
					</div>
				</div>
			</template>
			<template v-else-if="item.order_type == 5">
				<div class="img-box border-right" >
					<div class="flex">
						<img :src="item.design_mtm.design_data.effect_picture" />
						<div class="name">{{ item.design_mtm.t_name }}</div>
					</div>
				</div>
				<div class="detail-box border-right">
					<div class="">
						<div>{{ item.design_mtm.d_name }}</div>
						<div>数量：{{item.design_mtm.quantity}}</div>
						<div>单价：￥{{ item.design_mtm.price }}</div>
					</div>
				</div>
			</template>

			<div class="price-box border-right">
				<div class="price">￥{{item.total}}</div>
				<div>（含运费:￥{{ freight }}）</div>
			</div>
			<div class="status-box border-right">
				<div class="status">{{ item.status_name | orderStatusName }}</div>
				<div class="detail" @click="toDetail">订单详情</div>
				<!-- <div class="detail">查看物流</div> -->
			</div>
			<div class="action-box">

				<div class="action" v-if="item.command.includes('pay')" @click.stop="go2pay(item.order_id)">去付款</div>
				<div class="action" v-if="item.command.includes('revise_mtm')" @click.stop="go2revise(item)">修改量体</div>
				<div class="action" v-if="item.order_type==5" @click.stop="go2another(item)">再下一单</div>
				<div class="action" v-if="item.command.includes('receive_confirm')" @click.stop="go2confirm">确认收货</div>
				<div class="action" v-if="item.command.includes('receive_confirm')" @click.stop="go2refund(item)">申请返修</div>
				<div class="action" v-if="item.command.includes('comment')" @click.stop="go2comment">去评价</div>
				<div class="action action-cancel" v-if="item.command.includes('cancel')" @click.stop="go2cancel">取消订单</div>
			</div>
		</div>
		<div class="consignee-box">
			<span>收货人：{{item.consignee }}</span>
			<span>电话：{{item.mobile }}</span>
			<span>地址：{{item.province }}{{item.city }}{{item.zone }}{{item.address }}</span>
		</div>
	</div>
</template>

<script>
	import { cancelOrder, confirmOrder, MTemplateDetail } from "@/api"
	export default {
		name: 'orderitem',
		props: {
			item: Object,
			isEdit: {
				type: Boolean,
				default: false
			},
			index: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				isChecked: false,
			};
		},
		computed:{
			freight() {
				let freightItem =   this.item.totals.find((i)=>{
					return i.code == 'freight'
				})

				if(freightItem) {
					return freightItem.total
				}
				return 0
			}
		},
		methods: {
			checkedItem() {
				if (this.item.order_type != 5) {
					this.$Message.error("标准商品订单请单独支付")
					return
				}
				if (this.item.design_mtm.mtm_type == 6) {
					this.$Message.error("套装组合订单请单独支付")
					return
				}
				this.isChecked = !this.isChecked
				this.$emit('checkedItem', {
					isChecked: this.isChecked,
					index: this.index
				})
			},
			toDetail() {
				this.$router.push({
					path: "orderdetail",
					query: {order_id : this.item.order_id}
				});
			},
			go2pay(order_id) {
				this.$router.push({
					name: 'Paytype',
					query: {id:order_id}
				})
			},
			go2revise(item) {
				this.$router.push({
					name: 'OrderFigure',
					query: {id:item.order_id}
				})
			},
			async go2another(item) {
				let response = await MTemplateDetail({id: item.design_mtm.design_template_id})
				let category = response.data
				this.$store.commit('mtm/pick', {category:category, mtm_type: item.design_mtm.mtm_type})
				this.$store.commit('mtm/choose_another', {design_mtm: item.design_mtm})
				this.$router.push({name: 'Figure'})
			},
			go2confirm() {
				confirmOrder({order_id:this.item.order_id}).then((res)=>{
					if(res.code == 0) {
						let command =  this.item.command.filter((i)=>{
							return i != 'receive_confirm' && i != 'refund'
						})
						this.item.command = command
						this.item.Canceled = 'Complete'
					} else {
						this.$Message.error(res.msg)
					}

				})
			},
			go2refund(item) {
				this.$router.push({
					name: 'ApplyFixing',
					query: {id:item.order_id}
				})
			},
			go2cancel() {
				this.$Modal.confirm({
					title: '取消订单',
					content: '确认取消该订单？',
					onOk: () => {
						cancelOrder({order_id:this.item.order_id}).then((res)=>{
							if(res.code == 0) {
								let command =  this.item.command.filter((i)=>{
									return i != 'cancel' && i != 'pay'
								})
								this.item.command = command
								this.item.Canceled = 'Canceled'
								this.$emit('refresh')
							} else {
								this.$Message.error(res.msg)
							}

						})
					},
					onCancel: () => {
					}
				});
			},
			go2comment() {
				//TODO
			},

		}
	}
</script>

<style scoped lang="scss">
	.order-item {
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		margin-bottom: 10px;

		.order-title {
			position: relative;
			height: 40px;
			background: #F5F5F5;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;

			.title {
				color: #333333;
				font-size: 14px;

				span {
					margin-right: 40px;
				}
			}
		}

		.order-content {
			width: 100%;
			height: auto;
			display: flex;

			.img-box {
				width: 450px;
				height: auto;

				display: flex;
				padding: 20px;

				img {
					width: 100px;
					height: 100px;
					margin-right: 20px;
				}

				.name {
					font-size: 15px;
					font-family: PingFang SC;
					font-weight: bold;
					width: 288px;
					color: #333333;
					margin-top: 29px;
				}
			}

			.detail-box {
				width: 133px;
				height: auto;
				padding: 11px;
				font-size: 12px;
				font-weight: 400;
				color: #666;

				div {
					margin-top: 10px;
				}
			}

			.price-box {
				width: 130px;
				text-align: center;
				font-size: 12px;
				font-weight: 400;
				color: #666666;

				.price {
					margin-top: 46px;
					margin-bottom: 10px;
					font-size: 15px;
					font-weight: 600;
					color: #0F114A;
				}
			}

			.status-box {
				width: 88px;
				text-align: center;

				.status {
					margin-top: 30px;
					font-size: 14px;
					font-weight: bold;
					color: #BE0505;
				}

				.detail {
					font-size: 14px;
					font-weight: 400;
					color: #666666;
					margin-top: 10px;
					cursor: pointer;
				}
			}

			.action-box {
				width: 112px;
				font-size: 13px;
				text-align: center;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				.action {
					margin: 0 auto;
					width: 72px;
					height: 24px;
					line-height: 24px;
					background: #0F114A;
					border-radius: 3px;
					text-align: center;
					color: #EDD4AC;
					margin-top: 10px;
					cursor: pointer;
				}

				.action-cancel {
					margin: 0 auto;
					width: 72px;
					height: 24px;
					line-height: 24px;
					background: #FFFFFF;
					border-radius: 3px;
					text-align: center;
					color: #0F114A;
					margin-top: 10px;
					border: 1px solid #0F114A;

				}
			}


		}

		.border-right {
			border-right: 1px solid #EEEEEE;
		}
	}
	.flex{
		display: flex;
	}
	.consignee-box{
		padding: 10px 24px;
		font-size: 14px;
		border-top: 1px solid #EEEEEE;
		span{
			margin-right: 10px;
		}
	}

	.icon-checkbox {
		position: absolute;
		top: 8px;
		right: 30px;
	}
</style>
